import { TemperatureNurseryDomainService } from './domain';
import { TemperatureFactory } from './entity/temperatureFactory';

import type { Logger } from '@/infra/logger';
import type { WagakoNurseryIApi } from '@/infra/wagakoNurseryIApi';
import type { TemperatureJson } from '@/types/domain/temperature/entities/temperatureEntity';

/**
 * 体温アプリケーションサービス(施設)
 */
export class TemperatureNurseryApplicationService {
  private service!: TemperatureNurseryDomainService;

  private temperatureFactory = new TemperatureFactory();

  /**
   * Injection
   * @param wagakoNurseryApi wagakoNurseryApi
   * @param logger logger
   */
  public inject(
    wagakoNurseryApi: WagakoNurseryIApi,
    logger: Logger,
  ) {
    this.service = new TemperatureNurseryDomainService(logger);
    this.service.inject(wagakoNurseryApi);
  }

  /**
   * sendNurseryTemperature
   * @param input input
   */
  async sendNurseryTemperature(
    input: TemperatureJson,
  ) {
    const entity = this.temperatureFactory.createFromJson(input);
    await this.service.sendNurseryTemperature(entity);
  }

  /**
   * removeNurseryTemperature
   * @param input input
   */
  async removeNurseryTemperature(
    input: TemperatureJson,
  ) {
    const entity = this.temperatureFactory.createFromJson(input);
    await this.service.removeNurseryTemperature(entity);
  }
}
